import {
	AvailableProductsOptions,
	AvailableProductsOptions as AISAvailableProductsOptions,
	AvailableProductsLegacyResponse as AISAvailableProductsLegacyResponse,
	AvailableProductsResponse as AISAvailableProductsResponse,
} from '@atlassiansox/asc-stargate';

import { useBxpWebStargateClient } from '@/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client';

import { AsyncResult, useAsync } from './use-async';

export function useAvailableProducts({
	includeInvalidSites,
	includeInvalidBitbucketSite,
}: AvailableProductsOptions): AsyncResult<AISAvailableProductsLegacyResponse | null> {
	const stargateClient = useBxpWebStargateClient();

	return useAsync(
		() =>
			stargateClient.availableProductsLegacy({
				includeInvalidSites,
				includeInvalidBitbucketSite,
			}),
		[],
	);
}

export function useAISAvailableProducts({
	includeInvalidSites,
	includeInvalidBitbucketSite,
	removeNonAdminSites,
}: AISAvailableProductsOptions): AsyncResult<AISAvailableProductsResponse | null> {
	const stargateClient = useBxpWebStargateClient();

	return useAsync(
		() =>
			stargateClient.availableProducts({
				includeInvalidSites,
				includeInvalidBitbucketSite,
				removeNonAdminSites,
			}),
		[],
	);
}
